import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Miniacbusonrentinshirdi() {



  const cardData =
  {
    keyword: 'Mini AC Bus on Rent in Shirdi',
    heading: 'Sanavi Travels: Mini AC Bus on Rent in Shirdi',
    headingDescription: 'Sanavi Travels offers reliable Mini AC Bus on Rent in Shirdi, providing safe, comfortable, and air-conditioned transportation for small to medium-sized groups, families, and pilgrims visiting the holy town of Shirdi. Our fleet of well-maintained mini AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free and enjoyable journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Shirdi and nearby cities including Pune, Mumbai, Nashik, and Aurangabad, covering major attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted mini AC bus rental services in Shirdi, delivering comfort, safety, and a seamless travel experience for every trip.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the primary spiritual attraction in Shirdi, dedicated to the revered saint Sai Baba. Millions of devotees visit every year seeking blessings, inner peace, and spiritual guidance. The temple is well-organized, facilitating smooth darshan and participation in sacred aartis."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir houses the tomb of Sai Baba and is the heart of the Shirdi temple complex. Devotees experience profound devotion and calm while offering prayers, making it the central spiritual spot in Shirdi."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived and performed miracles for decades. The continuously burning dhuni (sacred fire) symbolizes protection, faith, and devotion, attracting pilgrims throughout the year."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the historic location where Sai Baba used to rest on alternate nights. On Thursdays and during festivals, ceremonial processions are held, maintaining the traditional practices associated with Sai Baba’s life."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time in meditation and tending to plants. The continuously burning Nanda Deep lamp adds to the peaceful and spiritual atmosphere."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically important as the place where Sai Baba was first welcomed to Shirdi. It marks the beginning of Sai Baba’s spiritual journey in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park that recreates key events from Sai Baba’s life using statues and traditional settings. It provides an educational and spiritual experience for visitors."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage commemorates one of Sai Baba’s closest disciples. Visitors come here to reflect on the deep spiritual bond between Sai Baba and his followers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located nearby, is famous for its Lord Shani temple and the open-door village tradition. Many pilgrims visit Shani Shingnapur along with Shirdi for a complete spiritual experience."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers recreational fun with water rides, wave pools, and family entertainment. It provides a refreshing break for families visiting Shirdi alongside spiritual activities."
  }
]
,



"services": [
  {
    "name": "Mini AC Bus Rent in Shirdi",
    "description": "Mini AC Bus Rent in Shirdi offers a comfortable and convenient travel solution for small groups, families, and corporate travelers visiting Shirdi. Fully air-conditioned with spacious seating and professional chauffeurs, this service ensures a smooth and safe journey. Ideal for short tours, temple visits, and group outings, it combines reliability, comfort, and affordability for all passengers."
  },
  {
    "name": "Mini Bus Hire Shirdi",
    "description": "Mini Bus Hire Shirdi provides flexible rental options for small groups traveling to Shirdi or nearby areas. With experienced drivers, air-conditioned interiors, and well-maintained vehicles, it ensures timely pickups, safe travel, and a hassle-free experience for family trips, religious tours, and sightseeing."
  },
  {
    "name": "AC Mini Bus Shirdi",
    "description": "AC Mini Bus Shirdi guarantees a cool and relaxing journey even during long-distance travel. Equipped with air-conditioning, spacious seating, and professional chauffeurs, it is perfect for families, small groups, and tourists seeking comfort, reliability, and safety."
  },
  {
    "name": "Luxury Mini Bus Shirdi",
    "description": "Luxury Mini Bus Shirdi provides a premium travel experience for small groups visiting Shirdi. High-end interiors, air-conditioning, and skilled chauffeurs ensure a stylish, comfortable, and smooth ride for families, corporate travelers, or VIP guests attending events or religious tours."
  },
  {
    "name": "Family Mini Bus Shirdi",
    "description": "Family Mini Bus Shirdi focuses on safe, comfortable, and stress-free travel for families visiting Shirdi. Spacious seating, air-conditioning, and professional drivers make journeys enjoyable, whether for temple visits, day trips, or small group excursions."
  },
  {
    "name": "Group Travel Mini Bus Shirdi",
    "description": "Group Travel Mini Bus Shirdi caters to small groups traveling together for religious, leisure, or corporate purposes. Comfortable, air-conditioned vehicles with trained chauffeurs ensure punctuality, safety, and a smooth journey for everyone in the group."
  },
  {
    "name": "Affordable Mini Bus Shirdi",
    "description": "Affordable Mini Bus Shirdi provides budget-friendly transport options without compromising on comfort or safety. Well-maintained mini buses with air-conditioning and experienced drivers make it an ideal choice for families, tourists, and small groups traveling to Shirdi."
  },
  {
    "name": "Chauffeur Driven Mini Bus",
    "description": "Chauffeur Driven Mini Bus ensures a stress-free travel experience with professional drivers handling navigation, traffic, and safety. Perfect for families, small groups, or corporate travel, it combines comfort, reliability, and punctuality for every journey to Shirdi."
  },
  {
    "name": "Best Mini Bus Service Shirdi",
    "description": "Best Mini Bus Service Shirdi delivers high-quality transport for small groups and families. Air-conditioned, well-maintained vehicles and skilled chauffeurs ensure safe, smooth, and timely travel for sightseeing, religious visits, corporate tours, and group events."
  },
  {
    "name": "Tourist Mini Bus Shirdi",
    "description": "Tourist Mini Bus Shirdi is ideal for travelers exploring Shirdi’s temples and nearby attractions. Air-conditioned mini buses with professional drivers provide a comfortable and organized sightseeing experience for families, small groups, and pilgrims."
  },
  {
    "name": "Wedding Mini Bus Shirdi",
    "description": "Wedding Mini Bus Shirdi provides convenient and stylish transport for small wedding parties or guests visiting Shirdi for weddings. Fully air-conditioned with professional chauffeurs, it ensures timely arrivals, comfort, and a smooth journey for all attendees."
  },
  {
    "name": "Corporate Mini Bus Shirdi",
    "description": "Corporate Mini Bus Shirdi is designed for business travelers and corporate groups visiting Shirdi. Comfortable, air-conditioned mini buses with trained chauffeurs ensure punctuality, safety, and reliable transportation for meetings, conferences, or corporate events."
  },
  {
    "name": "Online Bus Booking Shirdi",
    "description": "Online Bus Booking Shirdi allows users to reserve mini AC buses quickly and conveniently. Customers can select dates, pickup points, and travel preferences with instant confirmation, ensuring a smooth, organized, and hassle-free journey to Shirdi."
  },
  {
    "name": "Local Mini Bus Shirdi",
    "description": "Local Mini Bus Shirdi is ideal for short-distance travel within Shirdi and nearby locations. Comfortable, air-conditioned, and efficiently driven, this service provides convenient rides for temple visits, sightseeing, shopping, or personal errands."
  },
  {
    "name": "Shirdi Travel Mini Bus",
    "description": "Shirdi Travel Mini Bus offers reliable and flexible transport for families, small groups, and tourists visiting Shirdi. Air-conditioned interiors, professional drivers, and well-maintained vehicles ensure a safe, comfortable, and enjoyable journey for all travelers."
  }
],
"tableData": [
  ["Mini AC Bus Rent in Shirdi", "Mini Bus Hire Shirdi"],
  ["AC Mini Bus Shirdi", "Luxury Mini Bus Shirdi"],
  ["Family Mini Bus Shirdi", "Group Travel Mini Bus Shirdi"],
  ["Affordable Mini Bus Shirdi", "Chauffeur Driven Mini Bus"],
  ["Best Mini Bus Service Shirdi", "Tourist Mini Bus Shirdi"],
  ["Wedding Mini Bus Shirdi", "Corporate Mini Bus Shirdi"],
  ["Online Bus Booking Shirdi", "Local Mini Bus Shirdi"],
  ["Shirdi Travel Mini Bus", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Mini AC Bus on Rent in Shirdi with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Mini AC bus rentals in Shirdi, ideal for small group tours, family outings, pilgrimages, local travel, and airport transfers."
  },
  {
    "WhyChooseheading": "Air‑Conditioned and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Mini AC buses that ensure a smooth and enjoyable journey in and around Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local routes and nearby attractions, providing safe and timely transportation for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Mini AC bus rentals in Shirdi, inclusive of fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last‑minute changes for your Mini AC bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your travel schedule and group requirements in Shirdi."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Mini AC buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Mini AC bus rentals in Shirdi."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Mini AC buses on rent in Shirdi?',
    answer: 'Yes, Sanavi Travels offers Mini AC bus rentals in Shirdi for small group tours, pilgrimages, family trips, and local travel.'
  },
  {
    question: 'How can I book a Mini AC bus in Shirdi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the Mini AC buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all Mini AC buses provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with local Shirdi routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with local and nearby routes for safe and timely transportation.'
  },
  {
    question: 'Can I rent the Mini AC bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all Mini AC buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Mini AC bus rental.'
  },
  {
    question: 'What payment options are available for Mini AC bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for Mini AC bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all Mini AC bus bookings in Shirdi.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshpande',
    feedback: 'Booked a Mini AC bus in Shirdi for our family group tour. Comfortable ride and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    feedback: 'Great experience with the Mini AC bus rental in Shirdi. Clean bus, professional driver, and smooth journey.',
    rating: 5
  }
];






















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini AC Bus Rent in Shirdi - Sanavi Travels",
  "description": "Sanavi Travels offers Mini AC bus rental services in Shirdi for family trips, group travel, corporate tours, weddings, and tourist travel. Chauffeur-driven luxury mini buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "95"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Mini AC Bus Rent in Shirdi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Mini AC bus in Shirdi with Sanavi Travels for family trips, group travel, corporate tours, weddings, and tourist travel. Chauffeur-driven luxury mini buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Miniacbusonrentinshirdi;